export const MPS_SUPPORT_EMAIL = "support@mypatientspace.com";
